import { seed_is_initalised, useLocalStorage } from "../../Utils"
import Control from "./Title/Control"
import React, { useState, useCallback } from "react"
import ResultSet from "./Title/Result"
import TitleInit from "./Title/TitleInit"
import ControlInit from "./Title/ControlInit"
import ResultInit from "./Title/ResultInit"
import { defaultImportData, defaultProfile } from "../../DefaultEntries"
import { useTranslation } from "react-i18next"
import { add_byname } from "./Util/ProfileHandler"
import { BynameSeeds as Seeds } from "./Util/BynameSeeds"
import TitleError from "./Title/TitleError"

const unit_name = "RewardRandomPool_Byname"

const Nameplate = props => {
    const [userData, setUserData] = useLocalStorage("importData", defaultImportData)
    const [profileData, setProfileData] = useLocalStorage("profile", defaultProfile)

    const { t } = useTranslation()

    const init_current_seed = () => {
        const nns = new Seeds(profileData, userData)
        return nns.get_current_seed(userData)
    }

    const [currentSeed, setCurrentSeed] = useState(init_current_seed())
    const [displayResults, setDisplayResults] = useState([])
    const [possibleResults, setPossibleResults] = useState([])

    const initialised = seed_is_initalised(userData, unit_name)

    const updateSeedHandler = (newSeed, raw1, raw2) => {
        add_byname(raw1, raw2, profileData, setProfileData)
        setCurrentSeed(newSeed)
        const nns = new Seeds(profileData, userData)
        const original = nns.set_current_seed(userData, newSeed)
        setUserData(original)
        setDisplayResults([])
    }

    const calculateResultHandler = () => {
        const nns = new Seeds(profileData, userData)
        setDisplayResults(nns.calculateResultHandler(currentSeed))
    }

    const find_seed = entries => {
        const nns = new Seeds(profileData, userData)
        const potential_seeds = nns.find_seed(entries)
        setPossibleResults(potential_seeds)
    }

    const store_seed_from_finding = () => {
        if (possibleResults.length === 1) {
            updateSeedHandler(possibleResults[0][0].get_state(), possibleResults[0][1], possibleResults[0][2])
        }
    }

    const resetSeed = useCallback(() => {
        if (!window.confirm(t("misc:Common.DeleteConfirmation"))) return
        const nns = new Seeds(profileData, userData)
        const original = nns.null_seed(userData)
        setUserData(original)
    }, [userData, t, setUserData, profileData])

    const plausibility_check = () => {
        const nns = new Seeds(profileData, userData)
        const adj = nns.get_have_adjectives_catalog()
        const sub = nns.get_have_subjects_catalog()
        return adj.length === sub.length && adj.length >= 1
    }

    const get_adj_sub = () => {
        const nns = new Seeds(profileData, userData)
        const adj = nns.get_have_adjectives_catalog()
        const sub = nns.get_have_subjects_catalog()
        return [adj, sub]
    }

    const pc = plausibility_check()
    let additional = <></>
    if (!pc) {
        additional = <TitleError errors={get_adj_sub()} />
    }
    if (!initialised) {
        return (
            <>
                <TitleInit additional={additional} />
                <ControlInit findSeed={find_seed} localKey={unit_name} />
                <ResultInit possibleResults={possibleResults} storeRes={store_seed_from_finding} />
            </>
        )
    }

    return (
        <>
            <Control additional={additional} calculateResults={() => calculateResultHandler()} resetSeed={resetSeed} />
            <ResultSet results={displayResults} updateSeed={updateSeedHandler} />
        </>
    )
}

export default Nameplate
